export class Step2 {
  constructor() {}

  getnomofficiel = 'bloc_commun.simp.getnomofficiel';
  getspan1 = 'bloc_commun.simp.getspan1';
  getsiret = 'bloc_commun.simp.getsiret';
  getsiren = 'bloc_commun.simp.getsiren';
  getridet = 'bloc_commun.simp.getridet';
  gettahiti = 'bloc_commun.simp.gettahiti';
  getfrwf = 'bloc_commun.simp.getfrwf';
  getirep = 'bloc_commun.simp.getirep';
  gettvaintra = 'bloc_commun.simp.gettvaintra';
  getcodeidentificationnational = 'bloc_commun.simp.getcodeidentificationnational';
  getville = 'bloc_commun.simp.getville';
  getcp = 'bloc_commun.simp.getcp';
  getspan2 = 'bloc_commun.simp.getspan2';
  getoui = 'bloc_commun.simp.getoui';
  getnon = 'bloc_commun.simp.getnon';
  getgrpcoordonnateur = 'bloc_commun.simp.getgrpcoordonnateur';
  getdeptpub = 'bloc_commun.simp.getdeptpub';
  getrappel_liste_avi_ = 'bloc_commun.simp.getrappel_liste_avi_';

}
